import Metrics from '@spotahome/soyuz-tracking';

export const on360Load = () => {
  Metrics.hotjar.recordTag('360viewer');
};

export const on360ChangeScene = () => {
  Metrics.hotjar.recordTag(['change360Scene']);
};

export const on360FullScreenOn = () => {
  Metrics.hotjar.recordTag(['start360Fullscreen']);
};

export const on360FullScreenOff = () => {
  Metrics.hotjar.recordTag(['close360Fullscreen']);
};

export default {
  on360Load,
  on360ChangeScene,
  on360FullScreenOn,
  on360FullScreenOff
};
